export const MEDICAL_RESERVE_DOM_READY = 'domReady';
export const MEDICAL_RESERVE_INCOMING_SHARE = 'incomingShare';

export type MedicalReserveFile = {
  name: string;
  mimeType: string;
  file: File;
};

export type MedicalReserveShareMessage = {
  type: typeof MEDICAL_RESERVE_INCOMING_SHARE;
  files: Array<{ name: string; mimeType: string; blob: Blob }>;
};

type Listener = (files: MedicalReserveFile[]) => void;

let pending: MedicalReserveFile[] | null = null;
const listeners = new Set<Listener>();

export const offerMedicalReserveFiles = (files: MedicalReserveFile[]) => {
  if (!files.length) return;
  pending = files;
  listeners.forEach(listener => listener(files));
};

export const peekMedicalReserveFiles = () => pending;

export const takeMedicalReserveFiles = () => {
  const files = pending;
  pending = null;
  return files;
};

export const subscribeMedicalReserveFiles = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Send the shared files only after the medical-reserve iframe says its DOM is ready.
 * The embed listens for `{ type: 'incomingShare', files: [{ name, mimeType, blob }] }`.
 */
export const deliverMedicalReserveShare = (ready: boolean, post: (message: MedicalReserveShareMessage) => void) => {
  if (!ready) return false;
  const files = peekMedicalReserveFiles();
  if (!files || !files.length) return false;
  post({
    type: MEDICAL_RESERVE_INCOMING_SHARE,
    files: files.map(item => ({ name: item.name, mimeType: item.mimeType, blob: item.file }))
  });
  takeMedicalReserveFiles();
  return true;
};

export const resetMedicalReserveFilesForTests = () => {
  pending = null;
  listeners.clear();
};
